module.exports = __webpack_public_path__ + "559868e6cf9a00ad77e26c7143eec090.svg";